import { useMutation, useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api/client';
import type {
  CheckoutResponse,
  DonationCheckoutRequest,
  DonationStatusResponse,
  ImpactStats,
} from '@/lib/api/models';
import { unwrap } from '@/lib/api/request';

export function useImpactStats() {
  return useQuery<ImpactStats>({
    queryKey: ['impact-stats'],
    queryFn: () => unwrap(api.GET('/donations/impact')),
    staleTime: 5 * 60_000,
  });
}

export function useDonationStatus(reference: string) {
  return useQuery<DonationStatusResponse>({
    queryKey: ['donation', reference],
    queryFn: () =>
      unwrap(api.GET('/donations/{reference}', { params: { path: { reference } } })),
    // Poll while the gateway webhook may still be settling the status.
    refetchInterval: (query) =>
      query.state.data && ['succeeded', 'failed', 'refunded'].includes(query.state.data.status)
        ? false
        : 4000,
  });
}

export function useCreateCheckout() {
  return useMutation<CheckoutResponse, unknown, DonationCheckoutRequest>({
    mutationFn: (body) => unwrap(api.POST('/donations/checkout', { body })),
  });
}
